import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export class CatalogSlider {
	prevSelector = '.js-catalog-slider-prev';
	nextSelector = '.js-catalog-slider-next';

	constructor(container) {
		if (!container) return;
		this.container = container;

		this.init();
	}

	init() {
		const swiperEl = this.container.querySelector('.swiper');
		const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

		this.swiper = new Swiper(swiperEl, {
			modules: [Navigation],
			slidesPerView: 'auto',
			centeredSlides: true,
			spaceBetween: 8,
			loop: slidesCount > 2,
			navigation: {
				prevEl: this.container.querySelector(this.prevSelector),
				nextEl: this.container.querySelector(this.nextSelector),
			},
			breakpoints: {
				1000: {
					spaceBetween: 16,
				},
			},
		});
	}
}
